import React from 'react';

import '../global.css';
import '../styles/shared/modal.css';

export interface ConfirmProps {
    title: string;
    text: string;
    onConfirm: () => void | Promise<void>;
    closeModal: (open: boolean) => void;
}

const Confirm: React.FC<ConfirmProps> = ({ title, text, onConfirm, closeModal }) => {
    async function handleConfirm() {
        await onConfirm();
    }

    function handleClickOutside() {
        closeModal(false);
    }

    return (
        <div className="confirm_outer_container" onClick={handleClickOutside}>
            <div className="confirm_container">
                <p className="confirm_title">{title}</p>
                <p className="confirm_body">{text}</p>
                <div className="confirm_bottom">
                    <button type="button" onClick={() => closeModal(false)} className="confirm_button">
                        Cancel
                    </button>
                    <button type="button" onClick={handleConfirm} className="confirm_button">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Confirm;
